import Account from 'commons-general/models/Account/AccountModel.js';
import * as types from 'commons-general/actions/accountActionTypes.js';

export default function accountReducer(state = new Account(), action) {
    switch (action.type) {
        case types.SET_ACCOUNT:
            return action.account;

        default:
            return state;
    }
}
